import { render, staticRenderFns } from "./CommentMap.vue?vue&type=template&id=baa73b80"
import script from "./CommentMap.vue?vue&type=script&lang=js"
export * from "./CommentMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports